import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import Carousel from '../../../../components/Carousel'
import moment from 'moment/moment'
import AddToPanierButton from '../../demande/Components/AddToPanierButton'
import {useLocation} from 'react-router'
import {PrixPieceMarcherModal} from '../../vehicules/components/PrixPieceMarcherModal'
import {
  deleteClientAdresse,
  deletePrix,
  getDetailsPiece,
  getPieceMarchePrix,
  getRefOe,
  integrationArgus,
} from '../../../../components/requests'
import {LoadingData} from '../../../../components/LoadingData'
import {InfoTarifications} from '../../modifPrix/components/InfoTarifications'
import {PrixArgus} from '../../modifPrix/components/PrixArgus'
import {PrixTarification} from '../../modifPrix/components/PrixTarification'
import {PrixArgImport} from '../../modifPrix/components/PrixArgImport'
import {copyText} from '../../../../components/renders'
import {DetailsStockModal} from '../../modifPrix/components/DetailsStockModal'
import {ModelePieceOe} from '../../../../components/Models'
import Swal from 'sweetalert2'
import {toast} from 'react-toastify'

const isEmpty = (obj: any) => !obj || Object.keys(obj).length === 0 // pour verifier si un objet est vide ou pas
const DetailsModal = (props) => {
  const {
    data,
    dataPrix = null,
    pieces = [],
    idClientDemandePiece = null,
    setPieceToValidate,
    pieceToValidate,
    showNextModal = null,
    setDataModifPrix = null,
    isNothingToNext = false,
    setTotalPrixManuel = null,
    totalPrixManuel = null,
    totalNontraitee = null,
    setTotalNontraitee = null,
    onDeleteData = null,
  } = props
  const [imgArr, setImgArr] = useState<any>([])
  const location = useLocation()
  const state = location.state as any
  const [detail, setDetail] = useState<any>(data || null)
  const [loading, setLoading] = useState(false)
  const [dataPriceMarche, setDataPriceMarche] = useState<any>([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [showVehicle, setShowVehicle] = useState(false)
  const [countRef, setCountRef] = useState(0)
  const [idsArgus, setIdsArgus] = useState(null)
  const [dataRefOe, setDataRefOe] = useState<Array<ModelePieceOe>>([])

  const modalDismissRef = useRef<HTMLButtonElement | null>(null)
  const modalRef = useRef<HTMLDivElement | null>(null)
  const [checkCopy, setCheckCopy] = useState<string | null>(null)
  const vehicule = detail?.vehiculeEntre?.vehicule
  const vehiculeEntre = detail?.vehiculeEntre

  // Pour l'affichage de l'entête du modal fiche véhicule
  const vehicleElt = [
    vehicule?.modele?.marque?.nom,
    vehicule?.modele?.nom,
    vehiculeEntre?.immatriculation,
    vehiculeEntre?.numero,
  ]
  const infosV = vehicleElt.filter(Boolean).join(' - ')
  const vehicleHeader = `Fiche véhicule : ${infosV}`

  // Pour afficher la pièce suivante
  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % pieces.length)
  }

  // Pour afficher la pièce précédente
  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + pieces.length) % pieces.length)
  }

  const getEtatColorIndicator = () => {
    let etatColorIndicator
    const etat = detail?.etat?.libelle?.toLowerCase()
    if (etat) {
      switch (etat) {
        case 'très bien':
          etatColorIndicator = 'primary'
          break
        case 'bien':
          etatColorIndicator = 'success'
          break
        case 'moyen':
          etatColorIndicator = 'yellow'
          break
        case 'nc':
          etatColorIndicator = 'orange'
          break
        default:
          etatColorIndicator = 'grey'
          break
      }
      return etatColorIndicator
    } else return ''
  }

  // Pour sélectionner l'index en cours
  useEffect(() => {
    if (pieces.length) {
      const index = pieces?.findIndex((item) => item?.id === detail?.id)
      setCurrentIndex(index ?? 0)
    }
  }, [detail])

  const handleNext = () => {
    if (modalDismissRef.current) {
      modalDismissRef.current.click()
      setTimeout(() => {
        showNextModal(true)
      }, 1000)
    }
  }

  const handleDeleteRow = () => {
    Swal.fire({
      title: 'Attention',
      text: 'Le prix de cet article ne sera pas traité, merci de confirmer de votre volonté la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToastDelete = toast.loading('Suppression en cours...')
        deletePrix([dataPrix.id]).then((response) => {
          if (response?.status === 200) {
            toast.update(idToastDelete, {
              render: 'Suppression effectué avec succès',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
            })
            onDeleteData(dataPrix.id)
            setTotalPrixManuel((prev: number) => prev - 1)
            handleNext()
          }
        })
      }
    })
  }

  // Gestion des données à afficher (précédent - suivant)
  useEffect(() => {
    if (pieces.length) {
      const dataToShow = pieces[currentIndex]
      const updatedDetail = {
        ...dataToShow,
        prixVenteTTC: Number(
          Number(Number(dataToShow?.prix) * (1 + Number(dataToShow?.tauxTva) / 100))?.toFixed(2) ??
            0
        ),
      }
      setDetail(updatedDetail)
    }
  }, [currentIndex])

  useEffect(() => {
    if (data && !isEmpty(data)) {
      const updatedDetail = {
        ...data,
        prixVenteTTC: Number(
          Number(Number(data?.prix) * (1 + Number(data?.tauxTva) / 100))?.toFixed(2) ?? 0
        ),
      }
      setDetail(updatedDetail)
    }
  }, [data])

  useEffect(() => {
    const modal = modalRef.current

    const handleModalShown = () => {
      setShowVehicle(false)
    }

    if (modal) {
      modal.addEventListener('shown.bs.modal', handleModalShown)
    }

    if (modal) {
      modal.addEventListener('hidden.bs.modal', handleModalShown)
    }

    return () => {
      if (modal) {
        modal.removeEventListener('shown.bs.modal', handleModalShown)
        modal.removeEventListener('hidden.bs.modal', handleModalShown)
      }
    }
  }, [])

  useEffect(() => {
    if (dataPrix?.codePiece !== '' && dataPrix?.codePiece !== undefined) {
      setLoading(true)
      getDetailsPiece(dataPrix?.codePiece)
        .then((detailRequest) => {
          if (detailRequest.data !== undefined) {
            const updatedDetail = {
              ...detailRequest?.data,
              prixVenteTTC: Number(
                Number(
                  Number(detailRequest?.data?.prix) *
                    (1 + Number(detailRequest?.data?.tauxTva) / 100)
                )?.toFixed(2) ?? 0
              ),
            }
            setDetail(updatedDetail)
            setLoading(false)
          }
        })
        .catch((e) => {
          console.log('error', e)
          setLoading(false)
        })
    }
    if (dataPrix && dataPrix?.refConst) {
      let dataMetrique: any = {}
      let isHorsAlgo = false
      if (dataPrix?.metriques) {
        dataMetrique = JSON.parse(dataPrix?.metriques)
        if(dataMetrique?.libelleHorsAlgo !== null){
          isHorsAlgo = dataMetrique?.libelleHorsAlgo
        }
      }
      getRefOeData(dataPrix?.refConst, dataPrix?.codePiece, isHorsAlgo)
    }
  }, [dataPrix])

  // ----------------------------------
  const getRefOeData = (reference , codePiece, isHorsAlgo) => {
    getRefOe(reference, codePiece)
      .then((refRequest) => {
        if (refRequest !== undefined && refRequest.data !== undefined) {
          const data = refRequest?.data
          setDataRefOe(data)
          const idsString = data.map((item) => item.idPieceEntee).join(',')
          setCountRef( (isHorsAlgo === true || isHorsAlgo === 1) ? data.filter((item) => item.idModifPrix !== null).length : data.length)
          setIdsArgus(idsString)
        }
      })
      .catch((e) => {
        console.log('e', e)
      })
  }

  useEffect(() => {
    if (!showVehicle && dataPrix !== null && detail?.piece?.referenceConstructeur) {
      //données detail Marche_prix
      getPieceMarchePrix(detail?.piece?.referenceConstructeur).then((res) => {
        if (res.data !== undefined) {
          setDataPriceMarche(res.data)
        } else {
          console.log('error')
        }
      })
    }

    // Pour les photos de pièces
    if (showVehicle) return
    let arrTemp: any = []
    detail?.images?.length > 0 &&
      detail?.images?.map((i) => {
        arrTemp.push(i.image)
      })
    setImgArr(arrTemp)
  }, [detail, showVehicle])

  const getDayDiff = (date: Date) => {
    const now = new Date()
    const diff = now.getTime() - date.getTime()
    return Math.round(diff / (1000 * 60 * 60 * 24))
  }

  // Gestion d'images de véhicules
  useEffect(() => {
    if (!showVehicle) return

    const vehicule = detail?.vehiculeEntre
    if (!vehicule) return

    const immat = vehicule?.immatriculation
    const cloudfrontUrl = 'https://d1zsawkzupb9kl.cloudfront.net/'

    if (immat) {
      const firstImmatChar = immat.substring(0, 1)
      const arrTemp: string[] = []

      for (let i = 1; i <= 15; i++) {
        arrTemp.push(`Photos${firstImmatChar}/${immat}_${i}.jpg`)
      }

      const checkImages = async () => {
        try {
          const existingImages = await Promise.all(
            arrTemp.map(
              (relativeUrl) =>
                new Promise<string | null>((resolve) => {
                  const img = new Image()
                  img.onload = () => resolve(relativeUrl)
                  img.onerror = () => resolve(null)
                  img.src = `${cloudfrontUrl}${relativeUrl}`
                })
            )
          )

          const validImages = existingImages.filter((url): url is string => url !== null)
          setImgArr(validImages)
        } catch (error) {
          console.error('Erreur lors de la vérification des images :', error)
        }
      }

      checkImages()
    }
  }, [showVehicle, detail])

  const renderInfo = () => {
    const codePiece = `${detail?.piece?.typePiece?.sousCategorie.categorie.code}${detail?.piece?.typePiece?.sousCategorie.code}${detail?.piece?.typePiece?.code}${detail?.vehiculeEntre?.numero}`

    const capitalizaFirstletter = (str: string = '') => {
      if (str != null) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      }
    }

    return (
      <div className='overflow-auto' style={{maxHeight: '500px'}}>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence constructeur</div>
          <div className='d-flex gap-2'>
            {dataPrix !== null && detail?.piece?.referenceConstructeur ? (
              <div
                className='fs-4 bold text-hover-primary'
                data-bs-target='#detailsPrixModal'
                data-bs-toggle='modal'
                data-bs-dismiss='modal'
                data-tooltip-id='tooltip'
                data-tooltip-content='Details du prix pièce marché'
                data-tooltip-place='top'
                style={{cursor: 'pointer'}}
              >
                {detail?.piece?.referenceConstructeur}
              </div>
            ) : (
              <div className='fs-4 bold'>{detail?.piece?.referenceConstructeur || ''}</div>
            )}
            {detail?.piece?.referenceConstructeur &&
              (checkCopy !== detail?.piece?.referenceConstructeur ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(detail?.piece?.referenceConstructeur, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Prix constructeur (HT)</div>
          <div className='fs-4 bold'>
            {Number(detail?.piece?.prixConstructeur)?.toFixed(2) ?? ''} €
          </div>
        </div>
        {!dataPrix && (
          <div className='d-flex justify-content-between mb-3'>
            <div className='bold text-gray-600 fs-4'>Référence pièce</div>
            <div className='d-flex gap-2'>
              <div className='fs-4 bold'>
                {/*{detail?.piece?.typePiece?.sousCategorie.categorie.code}*/}
                {/*{detail?.piece?.typePiece?.sousCategorie.code}*/}
                {/*{detail?.piece?.typePiece?.code}*/}
                {/*{detail?.vehiculeEntre?.numero}*/}
                {detail?.code ? (
                  detail.code
                ) : (
                  <>
                    {detail?.piece?.typePiece?.sousCategorie?.categorie?.code}
                    {detail?.piece?.typePiece?.sousCategorie?.code}
                    {detail?.piece?.typePiece?.code}
                    {detail?.vehiculeEntre?.numero}
                  </>
                )}
              </div>
              {codePiece !== '' &&
                (checkCopy !== codePiece ? (
                  <i
                    className='ki-duotone ki-copy cursor-pointer fs-2'
                    onClick={(e) => handleCopie(codePiece, e)}
                  ></i>
                ) : (
                  <i className='ki-duotone ki-copy-success fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                ))}
            </div>
          </div>
        )}
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Etat</div>
          <div className='fs-4 bold'>
            <span
              className={`badge badge-light-${getEtatColorIndicator()} border border-light-${getEtatColorIndicator()} w-100 justify-content-center fs-5`}
            >
              {capitalizaFirstletter(detail?.etat?.libelle) || ''}
            </span>
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence BAC</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{detail?.stockageBac || ''}</div>
            {detail?.stockageBac &&
              (checkCopy !== detail?.stockageBac ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(detail?.stockageBac, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence casier</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{detail?.stockageAllee || ''}</div>
            {detail?.stockageAllee &&
              (checkCopy !== detail?.stockageAllee ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(detail?.stockageAllee, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Commentaire</div>
          <div
            className='fs-4 text-gray-700 text-end overflow-y-auto'
            style={{
              maxHeight: '150px',
              maxWidth: '20vw',
            }}
          >
            {detail?.commentaire || ''}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Date de stockage</div>
          <div className='fs-4 bold'>
            {detail?.stockageDate ? moment(detail?.stockageDate).format('DD/MM/YYYY') : ''}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Jour de stockage</div>
          <div className='fs-4 bold'>
            {detail?.stockageDate ? getDayDiff(new Date(detail?.stockageDate)) : ''}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Destination</div>
          <div className='fs-4 bold'>
            {detail?.destination ?? 'N/C'}
          </div>
        </div>
      </div>
    )
  }

  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  const renderPartialInfoVehicle = () => {
    const vehicleDetail = detail.vehiculeEntre
    return (
      <div className='overflow-auto' style={{maxHeight: '500px'}}>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Marque</div>
          <div className='fs-4 bold'>{vehicleDetail?.vehicule?.modele?.marque?.nom || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Modèle</div>
          <div className='fs-4 bold'>{vehicleDetail?.vehicule?.modele?.nom || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Immatriculation</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.immatriculation || ''}</div>
            {vehicleDetail?.immatriculation &&
              (checkCopy !== vehicleDetail?.immatriculation ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.immatriculation, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>NE</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.numero || ''}</div>
            {vehicleDetail?.numero &&
              (checkCopy !== vehicleDetail?.numero ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.numero, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Date première immatriculation</div>
          <div className='fs-4 bold'>
            {vehicleDetail?.datePremiereImmat == ''
              ? ''
              : moment(vehicleDetail?.datePremiereImmat)?.format('DD/MM/YYYY')}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>N° série</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.vin || ''}</div>
            {vehicleDetail?.vin &&
              (checkCopy !== vehicleDetail?.vin ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.vin, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
      </div>
    )
  }

  const renderInfoVehicle = () => {
    const vehicleDetail = detail.vehiculeEntre
    return (
      <div className='overflow-auto' style={{maxHeight: '500px'}}>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Marque</div>
          <div className='fs-4 bold'>{vehicleDetail?.vehicule?.modele?.marque?.nom || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Modèle</div>
          <div className='fs-4 bold'>{vehicleDetail?.vehicule?.modele?.nom || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Immatriculation</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.immatriculation || ''}</div>
            {vehicleDetail?.immatriculation &&
              (checkCopy !== vehicleDetail?.immatriculation ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.immatriculation, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Numéro d’identification</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.numero || ''}</div>
            {vehicleDetail?.numero &&
              (checkCopy !== vehicleDetail?.numero ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.numero, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Mise en circulation</div>
          <div className='fs-4 bold'>
            {vehicleDetail?.datePremiereImmat == ''
              ? ''
              : moment(vehicleDetail?.datePremiereImmat)?.format('DD/MM/YYYY')}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>N° série</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.vin || ''}</div>
            {vehicleDetail?.vin &&
              (checkCopy !== vehicleDetail?.vin ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.vin, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Genre</div>
          <div className='fs-4 bold'>{vehicleDetail.vehicule?.modele?.type?.code || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Puissance</div>
          <div className='fs-4 bold'>{vehicleDetail.vehicule?.modele?.puissance || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Boîte de vitesse</div>
          <div className='fs-4 bold'>{}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Type variante version</div>
          <div
            className='fs-4 text-gray-700 text-end overflow-y-auto'
            style={{maxHeight: '150px', maxWidth: '20vw'}}
          >
            {}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Date CG</div>
          <div className='fs-4 bold'>{}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Contrôle SIV</div>
          <div className='fs-4 bold'>{}</div>
        </div>
      </div>
    )
  }

  return (
    <>
      <style>
        {`
          #modal_details_cat .modal-dialog {
            max-height: calc(100vh - 1rem);
            max-height: calc(100dvh - 1rem);
          }
      
          #modal_details_cat .modal-content {
            display: flex;
            flex-direction: column;
            max-height: calc(100vh - 1rem);
            max-height: calc(100dvh - 1rem);
          }
      
          #modal_details_cat .modal-header,
          #modal_details_cat .modal-footer {
            flex-shrink: 0;
          }
      
          #modal_details_cat .modal-body {
            min-height: 0;
            overflow-y: auto;
          }
        `}
      </style>
      <div className='modal fade' tabIndex={-1} id='modal_details_cat' ref={modalRef}>
        <div
          className='modal-dialog modal-xl'
          style={{
            maxWidth: dataPrix !== null ? '1750px' : '',
            width: dataPrix !== null ? '95%' : '',
          }}
        >
          <div className='modal-content'>
            <div className='modal-header'>
              {dataPrix === null ? (
                <h4 className='modal-title'>
                  {loading
                    ? 'Détails pièces'
                    : !showVehicle
                    ? `Détails de ${detail?.piece?.typePiece?.nom || 'pièces'}`
                    : vehicleHeader}
                </h4>
              ) : (
                <h5></h5>
              )}
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                {!showVehicle && (
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                )}
              </div>
            </div>
            <div className='modal-body'>
              {loading ? (
                <LoadingData />
              ) : !isEmpty(detail) ? (
                <>
                  <div
                    className={
                      dataPrix !== null ? 'd-flex justify-content-between w-100 gap-5' : ''
                    }
                  >
                    {/* debut bloc du gauche */}
                    {dataPrix !== null && <InfoTarifications dataPrix={dataPrix} />}
                    {/* fin bloc du gauche */}
                    {/*debut bloc du droite*/}
                    <div>
                      {dataPrix !== null && (
                        <h4 className='mb-5'>
                          {!showVehicle
                            ? detail?.piece?.typePiece?.nom
                              ? `Détails de ${detail?.piece?.typePiece?.nom}`
                              : 'Détails pièces'
                            : vehicleHeader}
                        </h4>
                      )}
                      <div
                        className={
                          !showVehicle ? 'd-flex align-items-center justify-content-between' : ''
                        }
                      >
                        {pieces?.length > 0 && !showVehicle && (
                          <div style={{width: '40px', height: '40px'}}>
                            <button
                              onClick={prevSlide}
                              disabled={currentIndex === 0}
                              className='btn btn-light rounded-circle d-flex align-items-center justify-content-center'
                              style={{width: '40px', height: '40px'}}
                            >
                              <i className='ms-1 bi bi-chevron-left'></i>
                            </button>
                          </div>
                        )}

                        <div className='d-flex gap-4'>
                          <div style={{width: '600px'}}>
                            <Carousel
                              loading={true}
                              imagesArray={imgArr}
                              nomPiece={detail?.piece?.typePiece?.nom}
                              taille={'600x400'}
                              width={126}
                              index={currentIndex}
                              isVehic={showVehicle}
                              etatColorIndicator={
                                !showVehicle ? getEtatColorIndicator() : undefined
                              }
                            />
                            {!showVehicle && (
                              <div>
                                <div className='d-flex flex-row-reverse justify-content-between align-items-center'>
                                  <div className='fs-2 mb-4 mt-4 text-end'>
                                    Prix de vente TTC : {Number(detail?.prixVenteTTC)?.toFixed(2)} €
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className='card shadow-none d-flex flex-column w-50'>
                            <div className='mb-6'>
                              {dataPrix !== null ? (
                                <h4 className='modal-title ms-9 mt-n12'>
                                  Information du {showVehicle ? 'véhicule' : 'produit'}
                                </h4>
                              ) : (
                                <div className='card-header border-bottom-0 fs-2 d-flex align-items-center'>
                                  Information du {showVehicle ? 'véhicule' : 'produit'}
                                </div>
                              )}
                              <hr className={'text-gray-400 mx-9'} />
                              <div className='card-body mt-n7'>
                                <div>{!showVehicle ? renderInfo() : renderInfoVehicle()}</div>
                              </div>
                            </div>

                            {/* Affichage partielle des données du véhicule */}
                            {!showVehicle && (
                              <div>
                                <h4 className='modal-title ms-9 mt-n12'>Information du véhicule</h4>
                                <hr className={'text-gray-400 mx-9'} />
                                <div className='card-body mt-n7'>
                                  <div>{renderPartialInfoVehicle()}</div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {pieces?.length > 0 && !showVehicle && (
                          <div style={{width: '40px', height: '40px'}}>
                            <button
                              onClick={nextSlide}
                              disabled={currentIndex === pieces.length - 1}
                              className='btn btn-light rounded-circle d-flex align-items-center justify-content-center'
                              style={{width: '40px', height: '40px'}}
                            >
                              <i className='ms-1 bi bi-chevron-right'></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    {/*fin bloc du droite*/}
                  </div>
                </>
              ) : (
                <div
                  className='d-flex justify-content-center align-items-center'
                  style={{height: '50px'}}
                >
                  <span>Aucune pièce en stock trouvée !</span>
                </div>
              )}
            </div>
            <div className='modal-footer d-flex flex-column align-items-stretch gap-3'>
              {/* debut affichage du contenu resumé prix en bas pour les pièces importer */}
              {!isEmpty(detail) && dataPrix !== null &&
                (dataPrix?.metriques !== null ? (
                  dataPrix?.prixManuel === 1 && dataPrix?.traitee === 0 ? (
                    <PrixTarification
                      dataPrix={dataPrix}
                      showNextModal={showNextModal}
                      modalDismissRef={modalDismissRef}
                      setDataModifPrix={setDataModifPrix}
                      isNothingToNext={isNothingToNext}
                      countRef={countRef}
                      idsArgus={idsArgus}
                      setTotalPrixManuel={setTotalPrixManuel}
                      totalPrixManuel={totalPrixManuel}
                      totalNontraitee={totalNontraitee}
                      setTotalNontraitee={setTotalNontraitee}
                      dataRefOe={dataRefOe}
                    />
                  ) : (
                    <PrixArgus
                      dataPrixArgus={dataPrix}
                      setDataModifPrix={setDataModifPrix}
                      modalDismissRef={modalDismissRef}
                    />
                  )
                ) : (
                  <PrixArgImport dataPrix={dataPrix} />
                ))}
              {!isEmpty(detail) && dataPrix !== null && dataPrix?.metriques !== null && <hr/>}
              {/*  fin affichage du contenu resumé prix en bas pour les pièces importer */}
              <div className='d-flex flex-wrap align-items-center justify-content-end gap-2 w-100'>
                <button
                  type='button'
                  className={`btn btn-light ${!showVehicle ? 'd-none' : 'order-first'}`}
                  onClick={() => setShowVehicle(!showVehicle)}
                >
                  Retour
                </button>
                {/* bouton pour fermer le modal et supprimer la ligne */}
                {dataPrix !== null &&
                  dataPrix?.metriques !== null &&
                  dataPrix?.prixManuel === 1 &&
                  dataPrix?.traitee === 0 && (
                    <button
                      className='btn btn-warning'
                      data-bs-dismiss='modal'
                      onClick={handleDeleteRow}
                    >
                      Supprimer la gestion du tarif {!isNothingToNext && 'et passer au suivant'}
                    </button>
                  )}
                {/* bouton pour fermer le modal et passer au suivant sur le statut "à tarifier manuellement" sans faire le traitement "integer argus" */}
                {dataPrix !== null &&
                  dataPrix?.metriques !== null &&
                  dataPrix?.prixManuel === 1 &&
                  dataPrix?.traitee === 0 && (
                    <button className='btn btn-info' data-bs-dismiss='modal' onClick={handleNext}>
                      Ne pas traiter {!isNothingToNext && 'et passer au suivant'}
                    </button>
                  )}

                {/*Bouton Valider Panier */}
                {!showVehicle && pieces?.length > 0 && (
                  <AddToPanierButton
                    piece={detail}
                    state={state}
                    detailVehicle={{
                      marque: detail?.vehicule?.modele?.marque?.nom ?? '',
                      modele: detail?.vehicule?.modele?.nom ?? '',
                    }}
                    isDetailPiece={true}
                    isListPieceStock={false}
                    tauxRemise={0}
                    prixTransport={0}
                    idClientDemandePiece={detail?.idClientDemandePiece ?? idClientDemandePiece} // ici on prend idClientDemandePiece du detail et sinon idClientDemandePiece du props(util si venant de ListePieceStock)
                    quantityPiece={detail?.quantityPiece}
                    idTypePiece={0}
                    setPieceToValidate={setPieceToValidate}
                    pieceToValidate={pieceToValidate}
                  />
                )}

                <div className={`d-flex gap-3 ${dataPrix !== null ? 'order-first me-auto' : ''}`}>
                  {!showVehicle && (
                    <button
                      type='button'
                      className='btn btn-light'
                      onClick={() => setShowVehicle(!showVehicle)}
                    >
                      Voir véhicule
                    </button>
                  )}
                  {dataPrix !== null &&
                    dataPrix?.metriques !== null &&
                    dataPrix?.prixManuel === 1 &&
                    dataPrix?.traitee === 0 && (
                      <button
                        type='button'
                        className='btn btn-light cursor-pointer'
                        data-tooltip-id='tooltip'
                        data-tooltip-content='Details du piece en stock'
                        data-tooltip-place='right'
                        data-bs-target='#modalDetailsStock'
                        data-bs-toggle='modal'
                      >
                        Voir information du stock même ref OE
                      </button>
                    )}
                </div>
                <button
                  type='button'
                  className={`btn btn-light ${showVehicle ? 'd-none' : ''}`}
                  data-bs-dismiss='modal'
                  ref={modalDismissRef}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*appel du modal detail du prix par rapport au reference constructeur*/}
      <PrixPieceMarcherModal data={dataPriceMarche} />

      <DetailsStockModal dataRefOe={dataRefOe} handleCopie={handleCopie} checkCopy={checkCopy} />
    </>
  )
}

export {DetailsModal}
